import React, { forwardRef } from 'react';
import { Root } from '@domain/game.selection/version.container.styles';

const VersionContainer = forwardRef<any>((props, ref) => {
  return (
    <Root ref={ref} {...props}>
      v{process.env.REACT_APP_VERSION}
    </Root>
  );
});

export default VersionContainer;
